import styled from 'styled-components';

const StyledNoResults = styled.div`
  font-family: Roboto;
  text-align: center;
  margin-top: 15px;
  position: relative;
  top: 40px;
`;

export { StyledNoResults };
